import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toApiError } from '@/shared/api';
import { SessionRefreshError } from '@/shared/api/refreshFailure';
import { useAuth } from '@/shared/auth';

/** „Zurück zu StayOn HQ“: der Heimat-Workspace steht in der eigenen Anmeldung. */
export function backToHomeLabel(homeWorkspaceName: string | undefined): string {
  return homeWorkspaceName ? `Zurück zu ${homeWorkspaceName}` : 'Zurück zum eigenen Workspace';
}

/**
 * Beendet die Support-Sitzung und kehrt in die Heimatsitzung zurück. Antwortet der Server nicht,
 * bleibt die Sitzung bestehen — der Tab behauptet nie ein Ende, das der Server nicht kennt.
 */
export function useEndSupport() {
  const { endSupport, homeUser } = useAuth();
  const end = useMutation({
    mutationFn: endSupport,
    networkMode: 'always',
    onError: async (error) => {
      const problem = await toApiError(error);
      toast.error(
        error instanceof SessionRefreshError
          ? 'Ihre Anmeldung ließ sich gerade nicht erneuern – die Support-Sitzung läuft weiter. Bitte erneut beenden.'
          : problem.status === 0
            ? 'Keine Antwort vom Server – die Support-Sitzung läuft weiter. Bitte erneut beenden.'
            : `Die Support-Sitzung ließ sich nicht beenden (Fehler ${problem.title}). Sie läuft weiter.`,
      );
    },
  });
  return {
    end: () => end.mutate(),
    pending: end.isPending,
    backLabel: backToHomeLabel(homeUser?.workspaceName),
  };
}
